import React, { useContext, useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import AWS from 'aws-sdk'
import { getUUID } from '../../../utils/helpers';
import Button from 'react-bootstrap/Button';
import { ListGroup, Spinner } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { DataContext } from '../../../js/App';
import './photoVideo.scss';

const PhotoVideo = ({ name, type, fieldLabel, placeholder, labelPlaceholder }) => {
    const S3_BUCKET = 'insureapps';
    const REGION = 'eu-west-1';
    const extensionsArray = ['png', 'jpg', 'jpeg', 'JPG', 'JPEG', 'PNG', 'heic', 'HEIC', 'mp4', 'avi', 'mkv', 'webm', 'mpeg', 'mpg', 'mpg4', 'mov', 'MOV', 'm4v', 'M4V'];
    const imageExtensions = ['png', 'jpg', 'jpeg', 'JPG', 'JPEG', 'PNG', 'heic', 'HEIC'];
    const videoExtensions = ['mp4', 'avi', 'mkv', 'webm', 'mpeg', 'mpg', 'mpg4', 'mov', 'MOV', 'm4v', 'M4V'];
    AWS.config.update({
        accessKeyId: 'AKIAYEPFIPZIC3FHN4HF',
        secretAccessKey: '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'
    })
    const INSURE_APPS_BUCKET = new AWS.S3({
        params: { Bucket: S3_BUCKET },
        region: REGION,
    });

    const context = useContext(DataContext);
    const { handleUpdateValue } = context;
    const [progress, setProgress] = useState(0);
    const [selectedFile, setSelectedFile] = useState([]);
    const [selectedInvalidFile, setSelectedInvalidFile] = useState([]);
    const [uploadedFileNameToShow, setUploadedFileNameToShow] = useState([]);
    const [uploadingFiles, setUploadingFiles] = useState(false);
    const [show, setShow] = useState(false);
    const [awsError, setAwsError] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [uploadedFilesArray, setUploadedFilesArray] = useState([]);
    const [inputFileComponent, setInputFileComponent] = useState(null);

    useEffect(() => {
      }, [uploadedFileNameToShow]);
    const handleClose = () => {
        setShow(false);
    }
    const handleShow = () => setShow(true);

    const handleFileInput = (e) => {
        let filesArray = [];
        let validFiles = [];
        setInputFileComponent(e.target);
        Array.from(e.target.files).forEach(file => {
            filesArray.push(file);
        });

        validFiles = filesArray.filter(file => extensionsArray.indexOf(file.name.substring(file.name.lastIndexOf('.') + 1)) !== -1);
        const invalidFiles = filesArray.filter(file => extensionsArray.indexOf(file.name.substring(file.name.lastIndexOf('.') + 1)) === -1);

        setSelectedInvalidFile(invalidFiles);
        setSelectedFile(validFiles);
    }

    const uploadFile = () => {
        handleShow();
        setUploadingFiles(true);
        const tempFileArray = uploadedFiles;
        const tempUploadedFilesArray = uploadedFilesArray;
        const uploadedFileNameToShowTemp = [];
        selectedFile.forEach(file => {
            let extension = file.name.substr(file.name.lastIndexOf('.') + 1);
            let guid = getUUID();
            let fullKey = 'v2/' + guid + '.' + extension;
            const params = {
                ACL: 'public-read',
                Body: file,
                Bucket: S3_BUCKET,
                Key: fullKey
            };
            uploadedFileNameToShowTemp.push(file.name);
            INSURE_APPS_BUCKET.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress(Math.round((evt.loaded / evt.total) * 100))
                    if (((evt.loaded / evt.total) * 100) === 100) {
                        setUploadingFiles(false);
                    }
                })
                .send((err) => {
                    if (err) {
                        setAwsError(true);
                    } else {
                        tempFileArray.push({ 'remotePath': 'https://insureapps.s3.eu-west-1.amazonaws.com/' + fullKey, 'guid': guid });
                        tempUploadedFilesArray.push(file.name);                        
                    }
                })
        });
        setUploadedFileNameToShow(uploadedFileNameToShowTemp);
        setUploadedFiles(tempFileArray);
        setUploadedFilesArray(tempUploadedFilesArray);
        handleUpdateValue(name, tempFileArray);
        inputFileComponent.value = null;
    }

    const removeImage = (index) => {

        const tempFileArray = uploadedFiles;
        const tempUploadedFilesArray = uploadedFilesArray;

        tempFileArray.splice(index, 1);
        tempUploadedFilesArray.splice(index, 1);

        handleUpdateValue(name, tempFileArray);
        setUploadedFiles(tempFileArray);
        setUploadedFilesArray(tempUploadedFilesArray);
    }

    return (<>
        <Form.Group key={name} as={Row} controlId="formFile" className="mb-3">
            <Form.Label column sm="4" xl="5">
                Upload {type}
                {labelPlaceholder && (<span className="label-placeholder" dangerouslySetInnerHTML={{__html: placeholder}}></span>)}
            </Form.Label>
            <Col sm="5" xl="5">
                {type === "image" && (
                    <Form.Control multiple type="file" accept="image/png, image/jpeg, image/jpg" onChange={e => handleFileInput(e)} />
                )}
                {type === "video" && (
                    <Form.Control multiple type="file" accept="video/*" onChange={e => handleFileInput(e)} />
                )}
                {type !== "image" && type !== "video" && (
                    <Form.Control multiple type="file" onChange={e => handleFileInput(e)} />
                )}
            </Col>
            <Col sm="3" xl="2">
                <Button className='uploadMediaButton' disabled={selectedFile.length > 0 ? false : true} variant="primary" onClick={() => { uploadFile() }}>Upload</Button>
            </Col>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{uploadingFiles === true ? "Uploading media..." : "Media uploaded"}</Modal.Title>
                </Modal.Header>
                <Modal.Body> {uploadingFiles === true ? (
                    <><Row>
                        <Col sm="1"><Spinner animation="border" variant="primary" /></Col>
                        <Col><p>Uploading progress: {progress}%</p></Col>
                    </Row></>
                ) : (awsError === true ? "There was an error in uploading the media." : (
                    <>
                        {uploadedFileNameToShow && uploadedFileNameToShow.length > 0 ? (<>
                            <ListGroup className='mb-3'>
                                <ListGroup.Item variant="success">File Uploaded successfully</ListGroup.Item>
                                {uploadedFileNameToShow.map(fileName => (
                                    <ListGroup.Item>{fileName}</ListGroup.Item>
                                ))}
                            </ListGroup>
                            {selectedInvalidFile && selectedInvalidFile.length > 0 ? (
                                <>
                                    <ListGroup className='mb-3'>
                                        {selectedInvalidFile.length > 0 ? (<ListGroup.Item variant="danger">You have selected some invalid files. You can only upload image files (.jpg, .png)</ListGroup.Item>) : ""}
                                        {selectedInvalidFile.map(invalidFile => (
                                            <ListGroup.Item>{invalidFile.name}</ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                </>
                            ) : ""}
                        </>
                        ) : ""}
                    </>
                ))}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Form.Group>
        <Row className='mb-5'>
            {uploadedFiles.length > 0 && (
                <Col xs="12">
                    <h3>Media uploaded</h3>
                </Col>
            )}
            {uploadedFiles.map((file, index) => (
                <Col xs="12" sm="6" md="4" className='mb-3'>
                    <div className='uploaded-img'>
                        <div className='delete-image-button' onClick={() => removeImage(index)}>&times;</div>
                        {imageExtensions.includes(file.remotePath.substr(file.remotePath.lastIndexOf('.') + 1)) && (
                            <img className='img-fluid' src={file.remotePath} />
                        )}
                        {videoExtensions.includes(file.remotePath.substr(file.remotePath.lastIndexOf('.') + 1)) && (
                            <video className='img-fluid' src={file.remotePath} controls preload='none'/>
                        )}
                        <div className='img-name'>{uploadedFilesArray[index]}</div>
                    </div>
                </Col>
            ))}
        </Row>
    </>
    )
}

export default PhotoVideo;
